import { Card } from '@ipfabric/ui-components/Card/Card';
import { Message } from '@ipfabric/ui-components/Message/Message';
import { ApiTablePageView } from 'components/ApiTablePage/ApiTablePageView';
import { useSnapshotId } from 'utils/hooks/useSnapshotId';
import { AssignLabelsForm } from './AssignLabelsForm/AssignLabelsForm';
import { EditAssignedLabelForm } from './EditAssignedLabelForm/EditAssignedLabelForm';
import { useAssignedLabelsTable } from './useAssignedLabelsTable';

type AssignedLabelsTabContentProps = {
  initialRootId?: string;
};

type AssignedLabelsTabContentWithSnapshotProps =
  AssignedLabelsTabContentProps & {
    snapshotId: string;
  };

const AssignedLabelsTabContentWithSnapshot = ({
  initialRootId,
  snapshotId,
}: AssignedLabelsTabContentWithSnapshotProps) => {
  const table = useAssignedLabelsTable(snapshotId, initialRootId);

  return (
    <Card
      className='flex flex-col flex-1 rounded-tl-none min-h-0'
      data-testid='assigned-labels-panel'
      noShadow
    >
      <ApiTablePageView
        borderless
        model={table.apiTablePage}
        rowHeight={44}
        tableViewClassName='rounded-lg'
      />
      {table.confirmDeleteDialog.render()}
      {table.formOpen ? (
        <AssignLabelsForm
          onClose={() => table.setFormOpen(false)}
          onSaved={() => {
            table.setFormOpen(false);
            table.reloadTable();
          }}
          snapshotId={snapshotId}
        />
      ) : null}
      {table.editedAssignedLabel ? (
        <EditAssignedLabelForm
          assignment={table.editedAssignedLabel}
          onClose={() => table.setEditedAssignedLabel(null)}
          onSaved={() => {
            table.setEditedAssignedLabel(null);
            table.reloadTable();
          }}
          snapshotId={snapshotId}
        />
      ) : null}
    </Card>
  );
};

export const AssignedLabelsTabContent = ({
  initialRootId,
}: AssignedLabelsTabContentProps) => {
  const snapshotId = useSnapshotId();

  if (snapshotId === null) {
    return (
      <Card className='flex flex-col flex-1 rounded-tl-none min-h-0' noShadow>
        <Message
          message='Select a snapshot to view assigned labels'
          type='info'
          variant='plain'
        />
      </Card>
    );
  }

  return (
    <AssignedLabelsTabContentWithSnapshot
      initialRootId={initialRootId}
      snapshotId={snapshotId}
    />
  );
};
